import AvatarBase from './avatar-base';

export default class AvatarRound extends AvatarBase
{}
